<!-- 乘机人 列表 -->
<template>
  <div class="traver">
    <van-cell
      :title="title"
      :border="false"
    >
      <span
        v-show="addButton"
        class="addCxr main-color"
        @click="openEmplist"
      >
        + 添加
      </span>
    </van-cell>
    <!--  -->
    <div class="van-hairline--top">
      <van-cell
        v-for="(psg, index) in list"
        :key="index"
        class="traveler-item"
      >
        <!-- 成人 -->
        <van-row
          type="flex"
          align="center"
        >
          <van-col
            class="delete"
            @click="deletePsg(index, psg)"
            v-show="disabled == false"
          >
            <ld-icon
              class="red"
              type="iconjianshao"
            />
          </van-col>

          <van-col
            class="info"
            @click="editPsg(psg)"
          >
            <van-row class="font16 font-md">
              <span> {{ psg | getName }}</span>&nbsp;
              <van-tag plain>
                {{ psg.psgType | passengerType }}
              </van-tag>
            </van-row>

            <van-row class="font12 gray">
              <van-col span="18">
                {{ psg.cardName }} {{ psg.passport }}
              </van-col>
              <van-col
                span="6"
                class="text-right"
                v-show="psg.totalPrice"
              >
                <span class="font10 ">￥</span>
                <span class="font12">{{ psg.totalPrice }}</span>
              </van-col>
            </van-row>
          </van-col>

          <van-col
            class="edit"
            @click="editPsg(psg)"
            v-show="disabled == false"
          >
            <ld-icon
              class="gray"
              type="iconright"
            />
          </van-col>
        </van-row>
      </van-cell>
    </div>

    <emp-list
      ref="empList"
      :cplx="cplx"
      @selected="empCallBack"
      :element="element"
      :radio="radio"
      @radioSelected="radioSelected"
    />

    <ld-edit-psg
      ref="ldEditPsg"
      :cplx="cplx"
      :psg-info="psgInfo"
      @selected="getEditPsg"
      :element="element"
    />
  </div>
</template>

<script>
import { Tag, Cell } from 'vant'
import empList from 'Components/ldEmpList/index.vue'
import ldEditPsg from './ldEditPsg.vue'

export default {
  name: 'VisaTraver',
  components: {
    empList,
    ldEditPsg,
    [Cell.name]: Cell,
    [Tag.name]: Tag
  },
  props: {
    travelerList: {
      //需要展示的出行人
      type: [Array, Object],
      required: true,
      default: function() {
        return []
      }
    },
    personList: {
      //出差申请单中乘机人集合
      type: [Array, Object],
      default: function() {
        return []
      }
    },
    title: {
      type: String,
      default: '乘机人'
    },
    disabled: {
      //禁止滑动
      type: Boolean,
      default: false
    },
    addButton: {
      //显示增加 按钮
      type: Boolean,
      default: true
    },
    element: {
      type: String,
      default: ''
    },
    radio: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      psgInfo: {},
      list: [],
      storeName: 'visa/travelerList',
      cplx: '10913'
    }
  },
  methods: {
    radioSelected(info) {
      this.list = [info]
      this.$store.commit(this.storeName, [info])
    },
    empCallBack(info) {
      this.$store.commit(this.storeName, info)
    },
    getEditPsg(info) {
      this.list.forEach(item => {
        if (item.clkFlag == 1) {
          // 附属人
          if (info.clkFlag == 1) {
            if (item.contactsId && info.contactsId) {
              item = info
            }
          }
        } else if (item.clkFlag == 0) {
          // 常旅客
          if (info.clkFlag == 0) {
            if (item.contactsId && info.contactsId) {
              item = info
            }
          }
        } else if (item.clkFlag == 2) {
          // 员工
          if (info.clkFlag == 2) {
            if (item.empId && info.empId) {
              item = info
            }
          }
        }
        if (item.passengerType) {
          item.psgType = item.passengerType
        }
      })
      this.$store.commit(this.storeName, this.list)
      this.$emit('selected', this.list)
      this.$forceUpdate() // 强制更新
    },
    editPsg(psg) {
      if (this.disabled == false) {
        this.psgInfo = psg
        this.$refs.ldEditPsg.toggle()
      }
    },
    // 删除乘车人
    deletePsg(index, curPsg) {
      this.list.splice(index, 1)
      //当一个成人添加了儿童，删除成人后，关联的儿童也要自动删除
      if (curPsg && (curPsg.passengerType == 1 || !curPsg.passengerType)) {
        this.list = this.list.filter(
          psg => !(curPsg.idNumber === psg.idNumber && psg.passengerType === 2)
        )
      }
      this.$store.commit(this.storeName, this.list)
      this.$emit('selected', this.list)
    },
    openEmplist() {
      this.$refs.empList.toggle({ index: 1 })
    },
    toggle() {
      this.isShow = !this.isShow
    }
  },
  filters: {
    passengerType(val) {
      if (val == 2) {
        return '儿童'
      } else {
        return '成人'
      }
    }
  },
  watch: {
    'travelerList.length': {
      handler() {
        let arr = this.travelerList
        arr.forEach(item => {
          item.cardType = 2
          item.cardName = '护照'
        })
        this.list = arr
      },
      immediate: true
    }
  }
}
</script>

<style lang="less" scoped>
.traver {
  .addCxr {
    display: inline-block;
    padding: 0px 10px;
    border-radius: 15px;
    text-align: center;
    font-size: @font-size-14;
        border-width: 1px;
    border-style: solid;
  }

  .traveler-item {
    .delete {
      width: 35px;
    }

    .info {
      width: calc(100% - 86px);
    }

    .edit {
      width: 45px;
      margin-left: 5px;
    }
  }
}
</style>
